import { api } from './apiClient';

interface PaginatedResponse<T> {
  total: number;
  limit: number;
  skip: number;
  data: T[];
}

export interface User {
  id: number;
  email: string;
  googleId: string;
  auth0Id: string;
  companyId: string;
  firstName: string;
  lastName: string;
  lastLoggedIn: string;
  expiresAt: string;
  isActive: boolean;
  subscriptionPlan: string;
  isAdmin: boolean;
  companyName: string;
}

export interface CreateUserParams {
  firstName: string;
  lastName: string;
  email: string;
  companyId: number;
  isActive?: boolean;
  isAdmin: boolean;
  expiresAt?: number;
}

export interface RefreshTokenResponse {
  accessToken: string;
  user: User;
}

export const usersService = {
  // User Operations
  getUsers: async (): Promise<PaginatedResponse<User>> => {
    const response = await api.get<PaginatedResponse<User>>(
      '/users?isActive=true&$limit=1000&$skip=0'
    );
    return response;
  },

  getUser: async (id: number): Promise<User> => {
    const response = await api.get<User>(`/users/${id}`);
    return response;
  },

  createUser: async (user: CreateUserParams) => {
    return api.post<User & { invitationEmailSent?: boolean }>('/users', user);
  },

  updateUser: async (id: number, user: CreateUserParams) => {
    return api.patch(`/users/${id}`, user);
  },

  archiveUser: async (id: number): Promise<User> => {
    return api.patch(`/users/${id}`, { isActive: false });
  },

  updatePassword: async (id: number, password: string): Promise<User> => {
    return api.patch(`/users/${id}`, { password });
  },

  // Authentication Operations
  refreshToken: async (accessToken: string): Promise<RefreshTokenResponse> => {
    return api.post('/authentication', {
      strategy: 'refresh',
      accessToken,
    });
  },
};
